module.exports = __webpack_public_path__ + "img/pdi_logo.6df157ab.png";